export default __webpack_public_path__ + "static/media/hotspotbg1.2908b061.jpg";